import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  name: 'María',
  age: '32 años',
  quote: 'No sabía qué darle de comer y me daba miedo hacerlo mal. Siempre dudaba si lo estaba alimentando bien. En pocos días de aplicar el ebook, mi perro empezó a tener más energía y mejor digestión. Hoy lo veo mucho más feliz.',
  initial: 'M',
  color: 'bg-pink-100 text-pink-700',
  image: 'https://cdn.magicpatterns.com/uploads/ezzz4tDtpTjscqnQCc6VG6/IMG_4190.webp'
}, {
  name: 'Sofía',
  age: '28 años',
  quote: 'Pensé que era complicado, pero es súper fácil de seguir. Ahora sé exactamente qué darle y en qué cantidad. Me dio mucha tranquilidad.',
  initial: 'S',
  color: 'bg-purple-100 text-purple-700',
  image: 'https://cdn.magicpatterns.com/uploads/3Fe9X1HJCtCpztnhpvChNq/FBISHjERK_mid.webp'
}, {
  name: 'Lucía',
  age: '35 años',
  quote: 'Ahora preparo la comida para toda la semana en un solo día y me ahorro un montón de tiempo. Super práctico.',
  initial: 'L',
  color: 'bg-blue-100 text-blue-700',
  image: 'https://cdn.magicpatterns.com/uploads/5EsJuxWPE4gZu4UvcuChgR/IMG_4179.webp'
}, {
  name: 'Carla',
  age: '41 años',
  quote: 'Gastaba muchísimo en alimento de marca y no veía resultados. Con este ebook aprendí a hacer comidas naturales más económicas y mucho más saludables. Ahorro dinero y mi perro está mejor que nunca.',
  initial: 'C',
  color: 'bg-green-100 text-green-700'
}, {
  name: 'Valentina',
  age: '30 años',
  quote: 'Fue un antes y un después. Pasé de no saber qué darle a tener todo claro. Mi perro tiene más energía, mejor pelo y está mucho más activo.',
  initial: 'V',
  color: 'bg-orange-100 text-orange-700'
}, {
  name: 'Ana',
  age: '29 años',
  quote: 'Mi perro tenía la piel irritada y se rascaba constantemente. Probé de todo hasta que cambié su alimentación siguiendo esta guía. En menos de dos semanas la diferencia fue increíble. Ahora tiene el pelo brillante y dejó de rascarse.',
  initial: 'A',
  color: 'bg-teal-100 text-teal-700'
}];
export function Testimonials() {
  return <section className="py-6 md:py-8 px-4 bg-cream" data-id="element-182">
      <div className="max-w-6xl mx-auto" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-5" data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-3 font-serif" data-id="element-185">
            Lo que dicen quienes ya lo aplicaron
          </h2>
          <div className="flex justify-center items-center gap-3 mb-3" data-id="element-186">
            <div className="flex" data-id="element-187">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-188" />)}
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-2 gap-3" data-id="element-189">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-sage flex flex-col h-full overflow-hidden" data-id="element-190">
              {testimonial.image && <img src={testimonial.image} alt={`Foto de ${testimonial.name}`} className="w-full h-[200px] object-contain bg-gray-50" loading="lazy" decoding="async" data-id="element-191" />}
              <div className="p-4" data-id="element-192">
                <p className="flex items-center flex-wrap gap-x-1.5 text-sm text-charcoal mb-1" data-id="element-193">
                  <span className="font-bold" data-id="element-194">{testimonial.name}</span>
                  <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-emerald-600" data-id="element-195">
                    <BadgeCheckIcon className="w-3.5 h-3.5 fill-emerald-600 text-white" data-id="element-196" />
                    Verificada
                  </span>
                  <span className="text-gray-400" data-id="element-197">·</span>
                  <span className="text-gray-400 font-normal" data-id="element-198">
                    {testimonial.age}
                  </span>
                </p>
                <div className="flex mb-2" data-id="element-199">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-accent text-accent" data-id="element-200" />)}
                </div>
                <p className="text-gray-700 italic flex-1 text-base" data-id="element-201">
                  "{testimonial.quote}"
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}